import React from "react";
import styles from "../ui/Tabs.module.css"; // Reuse the existing Tabs CSS

const AlertTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["All", "Warnings", "Errors", "Events"]; // Define tab content list

  return (
    <div className={styles.container}>
      <div className="d-flex">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`me-2 pt-4 pb-3 px-4 fw-semibold fs-5 ${
              styles.inactiveButton
            } ${activeTab === tab ? styles.activeButton : ""} `}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AlertTabs;
